export default __webpack_public_path__ + "static/media/dover-cow.f9aa20b4.webp";